// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Swiper 6.5.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 5, 2021
 */
@font-face {
  font-family: "swiper-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-container-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-container-multirow > .swiper-wrapper {
  flex-wrap: wrap;
}

.swiper-container-multirow-column > .swiper-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
}

.swiper-container-free-mode > .swiper-wrapper {
  transition-timing-function: ease-out;
  margin: 0 auto;
}

.swiper-container-pointer-events {
  touch-action: pan-y;
}

.swiper-container-pointer-events.swiper-container-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  height: auto;
}

.swiper-container-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

/* 3D Effects */
.swiper-container-3d {
  perspective: 1200px;
}

.swiper-container-3d .swiper-wrapper,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}

.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-container-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-container-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}

.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

:root {
  --swiper-navigation-size: 44px;
  /*
  --swiper-navigation-color: var(--swiper-theme-color);
  */
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 10px;
  right: auto;
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  content: "prev";
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  content: "next";
}

.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
  --swiper-navigation-color: #ffffff;
}

.swiper-button-prev.swiper-button-black,
.swiper-button-next.swiper-button-black {
  --swiper-navigation-color: #000000;
}

.swiper-button-lock {
  display: none;
}

:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}

.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  background: #000;
  opacity: 0.2;
}

button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}

.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 6px 0;
  display: block;
}

.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}

.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
}

.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}

.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}

.swiper-container-horizontal > .swiper-pagination-progressbar,
.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}

.swiper-container-vertical > .swiper-pagination-progressbar,
.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-white {
  --swiper-pagination-color: #ffffff;
}

.swiper-pagination-black {
  --swiper-pagination-color: #000000;
}

.swiper-pagination-lock {
  display: none;
}

/* Scrollbar */
.swiper-scrollbar {
  border-radius: 10px;
  position: relative;
  -ms-touch-action: none;
  background: rgba(0, 0, 0, 0.1);
}

.swiper-container-horizontal > .swiper-scrollbar {
  position: absolute;
  left: 1%;
  bottom: 3px;
  z-index: 50;
  height: 5px;
  width: 98%;
}

.swiper-container-vertical > .swiper-scrollbar {
  position: absolute;
  right: 3px;
  top: 1%;
  z-index: 50;
  width: 5px;
  height: 98%;
}

.swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  left: 0;
  top: 0;
}

.swiper-scrollbar-cursor-drag {
  cursor: move;
}

.swiper-scrollbar-lock {
  display: none;
}

.swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.swiper-slide-zoomed {
  cursor: move;
}

/* Preloader */
:root {
  /*
  --swiper-preloader-color: var(--swiper-theme-color);
  */
}

.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  transform-origin: 50%;
  animation: swiper-preloader-spin 1s infinite linear;
  box-sizing: border-box;
  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius: 50%;
  border-top-color: transparent;
}

.swiper-lazy-preloader-white {
  --swiper-preloader-color: #fff;
}

.swiper-lazy-preloader-black {
  --swiper-preloader-color: #000;
}

@keyframes swiper-preloader-spin {
  100% {
    transform: rotate(360deg);
  }
}
/* a11y */
.swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
  transition-timing-function: ease-out;
}

.swiper-container-fade .swiper-slide {
  pointer-events: none;
  transition-property: opacity;
}

.swiper-container-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-cube {
  overflow: visible;
}

.swiper-container-cube .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
  visibility: hidden;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}

.swiper-container-cube .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
  transform-origin: 100% 0;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-prev,
.swiper-container-cube .swiper-slide-next + .swiper-slide {
  pointer-events: auto;
  visibility: visible;
}

.swiper-container-cube .swiper-slide-shadow-top,
.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}

.swiper-container-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 0;
}

.swiper-container-cube .swiper-cube-shadow:before {
  content: "";
  background: #000;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  filter: blur(50px);
}

.swiper-container-flip {
  overflow: visible;
}

.swiper-container-flip .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
}

.swiper-container-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-flip .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-flip .swiper-slide-shadow-top,
.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/swipper.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAAA;AAYC;EACG,2BAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,6BAAA;AAAJ;;AAEE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AACJ;;AACE;EACE,sBAAA;AAEJ;;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAGJ;;AADE;;EAEE,iCAAA;AAIJ;;AAFE;EACE,eAAA;AAKJ;;AAHE;EACE,eAAA;EACA,sBAAA;AAMJ;;AAJE;EACE,oCAAA;EACA,cAAA;AAOJ;;AALE;EACE,mBAAA;AAQJ;;AANE;EACE,mBAAA;AASJ;;AAPE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;AAUJ;;AARE;EACE,kBAAA;AAWJ;;AATE,gBAAA;AACA;;EAEE,YAAA;AAYJ;;AAVE;EACE,uBAAA;EACA,sCAAA;AAaJ;;AAXE,eAAA;AACA;EACE,mBAAA;AAcJ;;AAZE;;;;;;;EAOE,4BAAA;AAeJ;;AAbE;;;;EAIE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AAgBJ;;AAdE;EACE,gFAAA;AAiBJ;;AAfE;EACE,iFAAA;AAkBJ;;AAhBE;EACE,+EAAA;AAmBJ;;AAjBE;EACE,kFAAA;AAoBJ;;AAlBE,aAAA;AACA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mCAAA;AAqBJ;;AAnBE;EACE,aAAA;AAsBJ;;AApBE;EACE,8BAAA;AAuBJ;;AArBE;EACE,6BAAA;AAwBJ;;AAtBE;EACE,6BAAA;AAyBJ;;AAvBE;EACE,8BAAA;EACA;;GAAA;AA4BJ;;AAxBE;;EAEE,kBAAA;EACA,QAAA;EACA,oDAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gEAAA;AA2BJ;;AAzBE;;EAEE,aAAA;EACA,YAAA;EACA,oBAAA;AA4BJ;;AA1BE;;EAEE,yBAAA;EACA,wCAAA;EACA,+BAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;AA6BJ;;AA3BE;;EAEE,UAAA;EACA,WAAA;AA8BJ;;AA5BE;;EAEE,eAAA;AA+BJ;;AA7BE;;EAEE,WAAA;EACA,UAAA;AAgCJ;;AA9BE;;EAEE,eAAA;AAiCJ;;AA/BE;;EAEE,kCAAA;AAkCJ;;AAhCE;;EAEE,kCAAA;AAmCJ;;AAjCE;EACE,aAAA;AAoCJ;;AAlCE;EACE;;GAAA;AAuCJ;;AAnCE;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;AAsCJ;;AApCE;EACE,UAAA;AAuCJ;;AArCE,kBAAA;AACA;;;EAGE,YAAA;EACA,OAAA;EACA,WAAA;AAwCJ;;AAtCE,YAAA;AACA;EACE,gBAAA;EACA,YAAA;AAyCJ;;AAvCE;EACE,sBAAA;EACA,kBAAA;AA0CJ;;AAxCE;EACE,mBAAA;AA2CJ;;AAzCE;EACE,mBAAA;AA4CJ;;AA1CE;EACE,sBAAA;AA6CJ;;AA3CE;EACE,sBAAA;AA8CJ;;AA5CE;EACE,sBAAA;AA+CJ;;AA7CE;EACE,sBAAA;AAgDJ;;AA9CE;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAiDJ;;AA/CE;EACE,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EAGQ,gBAAA;AAkDZ;;AAhDE;EACE,eAAA;AAmDJ;;AAjDE;EACE,UAAA;EACA,qEAAA;AAoDJ;;AAlDE;EACE,WAAA;EACA,QAAA;EACA,oCAAA;AAqDJ;;AAnDE;EACE,aAAA;EACA,cAAA;AAsDJ;;AApDE;EACE,QAAA;EACA,2BAAA;EACA,UAAA;AAuDJ;;AArDE;EACE,qBAAA;EACA,sCAAA;AAwDJ;;AAtDE;EACE,aAAA;AAyDJ;;AAvDE;EACE,SAAA;EACA,2BAAA;EACA,mBAAA;AA0DJ;;AAxDE;EACE,uCAAA;AA2DJ;;AAzDE;EACE,wCAAA;AA4DJ;;AA1DE,aAAA;AACA;EACE,+BAAA;EACA,kBAAA;AA6DJ;;AA3DE;EACE,qEAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AA8DJ;;AA5DE;EACE,2BAAA;AA+DJ;;AA7DE;;EAEE,WAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;AAgEJ;;AA9DE;;EAEE,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AAiEJ;;AA/DE;EACE,kCAAA;AAkEJ;;AAhEE;EACE,kCAAA;AAmEJ;;AAjEE;EACE,aAAA;AAoEJ;;AAlEE,cAAA;AACA;EACE,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8BAAA;AAqEJ;;AAnEE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AAsEJ;;AApEE;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAuEJ;;AArEE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;AAwEJ;;AAtEE;EACE,YAAA;AAyEJ;;AAvEE;EACE,aAAA;AA0EJ;;AAxEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA2EJ;;AAzEE;;;EAGE,eAAA;EACA,gBAAA;EACA,mBAAA;AA4EJ;;AA1EE;EACE,YAAA;AA6EJ;;AA3EE,cAAA;AACA;EACE;;GAAA;AAgFJ;;AA5EE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,sBAAA;EACA,0EAAA;EACA,kBAAA;EACA,6BAAA;AA+EJ;;AA7EE;EACE,8BAAA;AAgFJ;;AA9EE;EACE,8BAAA;AAiFJ;;AA/EE;EACE;IACE,yBAAA;EAkFJ;AACF;AAhFE,SAAA;AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;AAkFJ;;AAhFE;EACE,oCAAA;AAmFJ;;AAjFE;EACE,oBAAA;EACA,4BAAA;AAoFJ;;AAlFE;EACE,oBAAA;AAqFJ;;AAnFE;;EAEE,oBAAA;AAsFJ;;AApFE;EACE,iBAAA;AAuFJ;;AArFE;EACE,oBAAA;EAEQ,2BAAA;EACR,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAwFJ;;AAtFE;EACE,oBAAA;AAyFJ;;AAvFE;EACE,wBAAA;AA0FJ;;AAxFE;;EAEE,oBAAA;AA2FJ;;AAzFE;;;;EAIE,oBAAA;EACA,mBAAA;AA4FJ;;AA1FE;;;;EAIE,UAAA;EAEQ,2BAAA;AA6FZ;;AA3FE;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AA8FJ;;AA5FE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EAEA,kBAAA;AA+FJ;;AA7FE;EACE,iBAAA;AAgGJ;;AA9FE;EACE,oBAAA;EAEQ,2BAAA;EACR,UAAA;AAiGJ;;AA/FE;EACE,oBAAA;AAkGJ;;AAhGE;;EAEE,oBAAA;AAmGJ;;AAjGE;;;;EAIE,UAAA;EAEQ,2BAAA;AAoGZ","sourcesContent":["/**\n * Swiper 6.5.0\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: March 5, 2021\n */\n\n @font-face {\n    font-family: 'swiper-icons';\n    src: url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');\n    font-weight: 400;\n    font-style: normal;\n  }\n  :root {\n    --swiper-theme-color: #007aff;\n  }\n  .swiper-container {\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: hidden;\n    list-style: none;\n    padding: 0;\n    /* Fix of Webkit flickering */\n    z-index: 1;\n  }\n  .swiper-container-vertical > .swiper-wrapper {\n    flex-direction: column;\n  }\n  .swiper-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    display: flex;\n    transition-property: transform;\n    box-sizing: content-box;\n  }\n  .swiper-container-android .swiper-slide,\n  .swiper-wrapper {\n    transform: translate3d(0px, 0, 0);\n  }\n  .swiper-container-multirow > .swiper-wrapper {\n    flex-wrap: wrap;\n  }\n  .swiper-container-multirow-column > .swiper-wrapper {\n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n  .swiper-container-free-mode > .swiper-wrapper {\n    transition-timing-function: ease-out;\n    margin: 0 auto;\n  }\n  .swiper-container-pointer-events {\n    touch-action: pan-y;\n  }\n  .swiper-container-pointer-events.swiper-container-vertical {\n    touch-action: pan-x;\n  }\n  .swiper-slide {\n    flex-shrink: 0;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    transition-property: transform;\n  }\n  .swiper-slide-invisible-blank {\n    visibility: hidden;\n  }\n  /* Auto Height */\n  .swiper-container-autoheight,\n  .swiper-container-autoheight .swiper-slide {\n    height: auto;\n  }\n  .swiper-container-autoheight .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height;\n  }\n  /* 3D Effects */\n  .swiper-container-3d {\n    perspective: 1200px;\n  }\n  .swiper-container-3d .swiper-wrapper,\n  .swiper-container-3d .swiper-slide,\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom,\n  .swiper-container-3d .swiper-cube-shadow {\n    transform-style: preserve-3d;\n  }\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }\n  .swiper-container-3d .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-container-3d .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-container-3d .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  /* CSS Mode */\n  .swiper-container-css-mode > .swiper-wrapper {\n    overflow: auto;\n    scrollbar-width: none;\n    /* For Firefox */\n    -ms-overflow-style: none;\n    /* For Internet Explorer and Edge */\n  }\n  .swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n    display: none;\n  }\n  .swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: start start;\n  }\n  .swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n    scroll-snap-type: x mandatory;\n  }\n  .swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n    scroll-snap-type: y mandatory;\n  }\n  :root {\n    --swiper-navigation-size: 44px;\n    /*\n    --swiper-navigation-color: var(--swiper-theme-color);\n    */\n  }\n  .swiper-button-prev,\n  .swiper-button-next {\n    position: absolute;\n    top: 50%;\n    width: calc(var(--swiper-navigation-size) / 44 * 27);\n    height: var(--swiper-navigation-size);\n    margin-top: calc(-1 * var(--swiper-navigation-size) / 2);\n    z-index: 10;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--swiper-navigation-color, var(--swiper-theme-color));\n  }\n  .swiper-button-prev.swiper-button-disabled,\n  .swiper-button-next.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: auto;\n    pointer-events: none;\n  }\n  .swiper-button-prev:after,\n  .swiper-button-next:after {\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    text-transform: none !important;\n    letter-spacing: 0;\n    text-transform: none;\n    font-variant: initial;\n    line-height: 1;\n  }\n  .swiper-button-prev,\n  .swiper-container-rtl .swiper-button-next {\n    left: 10px;\n    right: auto;\n  }\n  .swiper-button-prev:after,\n  .swiper-container-rtl .swiper-button-next:after {\n    content: 'prev';\n  }\n  .swiper-button-next,\n  .swiper-container-rtl .swiper-button-prev {\n    right: 10px;\n    left: auto;\n  }\n  .swiper-button-next:after,\n  .swiper-container-rtl .swiper-button-prev:after {\n    content: 'next';\n  }\n  .swiper-button-prev.swiper-button-white,\n  .swiper-button-next.swiper-button-white {\n    --swiper-navigation-color: #ffffff;\n  }\n  .swiper-button-prev.swiper-button-black,\n  .swiper-button-next.swiper-button-black {\n    --swiper-navigation-color: #000000;\n  }\n  .swiper-button-lock {\n    display: none;\n  }\n  :root {\n    /*\n    --swiper-pagination-color: var(--swiper-theme-color);\n    */\n  }\n  .swiper-pagination {\n    position: absolute;\n    text-align: center;\n    transition: 300ms opacity;\n    transform: translate3d(0, 0, 0);\n    z-index: 10;\n  }\n  .swiper-pagination.swiper-pagination-hidden {\n    opacity: 0;\n  }\n  /* Common Styles */\n  .swiper-pagination-fraction,\n  .swiper-pagination-custom,\n  .swiper-container-horizontal > .swiper-pagination-bullets {\n    bottom: 10px;\n    left: 0;\n    width: 100%;\n  }\n  /* Bullets */\n  .swiper-pagination-bullets-dynamic {\n    overflow: hidden;\n    font-size: 0;\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative;\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet {\n    width: 8px;\n    height: 8px;\n    display: inline-block;\n    border-radius: 50%;\n    background: #000;\n    opacity: 0.2;\n  }\n  button.swiper-pagination-bullet {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n  }\n  .swiper-pagination-clickable .swiper-pagination-bullet {\n    cursor: pointer;\n  }\n  .swiper-pagination-bullet-active {\n    opacity: 1;\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  }\n  .swiper-container-vertical > .swiper-pagination-bullets {\n    right: 10px;\n    top: 50%;\n    transform: translate3d(0px, -50%, 0);\n  }\n  .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 6px 0;\n    display: block;\n  }\n  .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px;\n  }\n  .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    display: inline-block;\n    transition: 200ms transform, 200ms top;\n  }\n  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 0 4px;\n  }\n  .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap;\n  }\n  .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 200ms transform, 200ms left;\n  }\n  .swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 200ms transform, 200ms right;\n  }\n  /* Progress */\n  .swiper-pagination-progressbar {\n    background: rgba(0, 0, 0, 0.25);\n    position: absolute;\n  }\n  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top;\n  }\n  .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    transform-origin: right top;\n  }\n  .swiper-container-horizontal > .swiper-pagination-progressbar,\n  .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0;\n  }\n  .swiper-container-vertical > .swiper-pagination-progressbar,\n  .swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n  .swiper-pagination-white {\n    --swiper-pagination-color: #ffffff;\n  }\n  .swiper-pagination-black {\n    --swiper-pagination-color: #000000;\n  }\n  .swiper-pagination-lock {\n    display: none;\n  }\n  /* Scrollbar */\n  .swiper-scrollbar {\n    border-radius: 10px;\n    position: relative;\n    -ms-touch-action: none;\n    background: rgba(0, 0, 0, 0.1);\n  }\n  .swiper-container-horizontal > .swiper-scrollbar {\n    position: absolute;\n    left: 1%;\n    bottom: 3px;\n    z-index: 50;\n    height: 5px;\n    width: 98%;\n  }\n  .swiper-container-vertical > .swiper-scrollbar {\n    position: absolute;\n    right: 3px;\n    top: 1%;\n    z-index: 50;\n    width: 5px;\n    height: 98%;\n  }\n  .swiper-scrollbar-drag {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 10px;\n    left: 0;\n    top: 0;\n  }\n  .swiper-scrollbar-cursor-drag {\n    cursor: move;\n  }\n  .swiper-scrollbar-lock {\n    display: none;\n  }\n  .swiper-zoom-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  .swiper-zoom-container > img,\n  .swiper-zoom-container > svg,\n  .swiper-zoom-container > canvas {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  .swiper-slide-zoomed {\n    cursor: move;\n  }\n  /* Preloader */\n  :root {\n    /*\n    --swiper-preloader-color: var(--swiper-theme-color);\n    */\n  }\n  .swiper-lazy-preloader {\n    width: 42px;\n    height: 42px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -21px;\n    margin-top: -21px;\n    z-index: 10;\n    transform-origin: 50%;\n    animation: swiper-preloader-spin 1s infinite linear;\n    box-sizing: border-box;\n    border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n    border-radius: 50%;\n    border-top-color: transparent;\n  }\n  .swiper-lazy-preloader-white {\n    --swiper-preloader-color: #fff;\n  }\n  .swiper-lazy-preloader-black {\n    --swiper-preloader-color: #000;\n  }\n  @keyframes swiper-preloader-spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  /* a11y */\n  .swiper-container .swiper-notification {\n    position: absolute;\n    left: 0;\n    top: 0;\n    pointer-events: none;\n    opacity: 0;\n    z-index: -1000;\n  }\n  .swiper-container-fade.swiper-container-free-mode .swiper-slide {\n    transition-timing-function: ease-out;\n  }\n  .swiper-container-fade .swiper-slide {\n    pointer-events: none;\n    transition-property: opacity;\n  }\n  .swiper-container-fade .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-container-fade .swiper-slide-active,\n  .swiper-container-fade .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-container-cube {\n    overflow: visible;\n  }\n  .swiper-container-cube .swiper-slide {\n    pointer-events: none;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    z-index: 1;\n    visibility: hidden;\n    transform-origin: 0 0;\n    width: 100%;\n    height: 100%;\n  }\n  .swiper-container-cube .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-container-cube.swiper-container-rtl .swiper-slide {\n    transform-origin: 100% 0;\n  }\n  .swiper-container-cube .swiper-slide-active,\n  .swiper-container-cube .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-container-cube .swiper-slide-active,\n  .swiper-container-cube .swiper-slide-next,\n  .swiper-container-cube .swiper-slide-prev,\n  .swiper-container-cube .swiper-slide-next + .swiper-slide {\n    pointer-events: auto;\n    visibility: visible;\n  }\n  .swiper-container-cube .swiper-slide-shadow-top,\n  .swiper-container-cube .swiper-slide-shadow-bottom,\n  .swiper-container-cube .swiper-slide-shadow-left,\n  .swiper-container-cube .swiper-slide-shadow-right {\n    z-index: 0;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n  }\n  .swiper-container-cube .swiper-cube-shadow {\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n    z-index: 0;\n  }\n  .swiper-container-cube .swiper-cube-shadow:before {\n    content: '';\n    background: #000;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    -webkit-filter: blur(50px);\n    filter: blur(50px);\n  }\n  .swiper-container-flip {\n    overflow: visible;\n  }\n  .swiper-container-flip .swiper-slide {\n    pointer-events: none;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n    z-index: 1;\n  }\n  .swiper-container-flip .swiper-slide .swiper-slide {\n    pointer-events: none;\n  }\n  .swiper-container-flip .swiper-slide-active,\n  .swiper-container-flip .swiper-slide-active .swiper-slide-active {\n    pointer-events: auto;\n  }\n  .swiper-container-flip .swiper-slide-shadow-top,\n  .swiper-container-flip .swiper-slide-shadow-bottom,\n  .swiper-container-flip .swiper-slide-shadow-left,\n  .swiper-container-flip .swiper-slide-shadow-right {\n    z-index: 0;\n    -webkit-backface-visibility: hidden;\n            backface-visibility: hidden;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
